<template>
  <!-- this is purely a test harness to allow test of Axios API Calls, and data parse-->
  <div>

    <b-button variant="outline-info"  v-on:click="showWizard()">Commissioning Wizard</b-button>

    <b-button variant="outline-info"  v-on:click="showCALWizard('eui-a8610a32311a7b06','O1')">Calibration Wizard</b-button>

    <hr/>
    <hr/>
    <Breaches/>


    <b-modal
            size="xl"
            header-bg-variant="light"
            header-text-variant="dark"
            ref="ComWizard"
            id="ComWizard"
            title="Device Commissioning"
            hide-footer>
            <b-card>
            <COMWizard @WizardComplete="FinishWizard" />
            </b-card>

        </b-modal>

        <b-modal
            size="xl"
            header-bg-variant="light"
            header-text-variant="dark"
            ref="CalWizard"
            id="CalWizard"
            title="Device Calibrations"
            hide-footer>
            <b-card>
            <CALWizard @WizardComplete="FinishCALWizard" :Type="Type" :ID="ID"/>
            </b-card>

        </b-modal>
    <!--   <button v-on:click="returnLocations()">Locations</button>
     <H2> Enter table name </H2>
      <input type="text" v-model="table_name">
          <button v-on:click="CallApi(table_name)">Test</button>
<H2>Full Response</H2>
<p>{{info}}</p>
<H2>Field Names</H2>
<p v-if="done">{{this.info.data.field_names}}</p>
<H2>Values</H2>
<p v-if="done">{{this.info.data.Values}}</p>

<H2>Full Response</H2>
<p>{{ this.items }}</p>
<p>{{ this.UserHeaders }}</p>

 <div>
      <H2> Enter Location </H2>
      <input type="text" v-model="location">
      <button v-on:click="CallAlarmApi(location)">TestAlarms</button>
      <button v-on:click="CallAlarmAPI()">Test API</button>
<H2>Full Response</H2>
<p>items: {{this.items}}</p>
<p>User Header: {{this.UserHeaders}}</p>
<br>
<br>
<b-table hover striped dark :items="this.items" :fields="this.UserHeaders" show-empty empty-text="Please try different location">
      <template v-slot:empty="scope">
        <h4>{{ scope.emptyText }}</h4>
      </template>
</b-table>

 </div>-->


  </div>
</template>

<script>
import axios from "axios";
import COMWizard from "../components/CommissionWizard/COMWizard.vue";
import CALWizard from "../components/CalibrationWizard/CALWizard.vue";
import Breaches from "../components/SeniorUserComponents/Breaches.vue"

export default {
  props:['DataPass','Type','ID'],
  components: {
        COMWizard,
        CALWizard,
        Breaches
    },
  mounted() {
    //axios.get('https://jsonplaceholder.typicode.com/users/')
    //let config = {'x-api-key': 'NbXi6fRPzS3ldUKOBMGHleSEiwjjUmX6InALhupb'};
    //let baseUrl = 'https://81vec86leg.execute-api.eu-west-2.amazonaws.com/" +
    //   this.$environment +
    //   "/resource?table_name=Location'
    //axios.get(baseUrl, {headers: config})
    //.then ( response => (this.info =response))
  },
  data() {
    return {
      info: null,
      response: null,
      table_name: "",
      Values: null,
      FieldNames: null,
      done: false,
      location: "",
      ArrTest: [],
      items: null,
      UserHeaders: null,
      selectedSearch: "",
      response2: "test",
      UnitSearchparam: null,
      searchUnitID: null,
      searchUnitStatus: null,
      UnitStatusparam: null,
      searchUnitsLocation: null,
      UnitLocationparam: null,
      UnitLevelparam: null,
      searchUnitLevel: null,
      UserSearchparam: null,
      searchUserID: null,
      Locationparam: null,
      searchLocation: null,
      LocationTrustparam: null,
      searchLocationbyTrust: null,
      searchLocationbyArea: null,
      LocationAreaparam: null,
      UserLocationparam: null,
      searchUsersLocation: null,
    };
  },
  methods: {

        showWizard(){
            this.$refs["ComWizard"].show();
        },
        FinishWizard(){
            this.$refs["ComWizard"].hide();
            console.log("Data has been submitted")
        },
        showCALWizard(id,devicetype){
          this.ID = id,
          this.Type = devicetype,
          this.$refs["CalWizard"].show();
        },
        FinishCALWizard(){
            this.$refs["CalWizard"].hide();
            console.log("data has been submitted")
        },
    CallApi: function() {
      let config = { "x-api-key": "NbXi6fRPzS3ldUKOBMGHleSEiwjjUmX6InALhupb" };
      let table_name = this.table_name;
      let url =
        "https://81vec86leg.execute-api.eu-west-2.amazonaws.com/" +
        this.$environment +
        "/resource?table_name=";
      let getUrl = url + table_name;
      axios
        .get(getUrl, { headers: config })
        .then((response) => (this.info = response))
        .finally(() => (this.done = true));
    },

    CallAlarmAPI: function() {
      let config = { "x-api-key": "NbXi6fRPzS3ldUKOBMGHleSEiwjjUmX6InALhupb" };
      let location = "'" + this.location + "'";
      let url =
        "https://r46t6xqou3.execute-api.eu-west-2.amazonaws.com/" +
        this.$environment +
        "/resource?location=";
      let getUrl = url + location;
      axios.get(getUrl, { headers: config }).then((response) => {
        this.testing = response.data.field_names;
        this.items = response.data.Values;
        for (let i = 0; i < this.testing.length; i++) {
          var QuoteStr = "" + i + "";
          this.ArrTest.push({ key: QuoteStr, label: this.testing[i] });
        }
        this.UserHeaders = this.ArrTest;
        this.ArrTest = [];
      });
    },

    returnLocations: function() {
      let config = { "x-api-key": "NbXi6fRPzS3ldUKOBMGHleSEiwjjUmX6InALhupb" };
      let url =
        "https://m59kpjvq25.execute-api.eu-west-2.amazonaws.com/" +
        this.$environment +
        "/resource?table_name=Location";
      axios.get(url, { headers: config }).then((response) => {
        this.testing = response.data.field_names;
        this.items = response.data.Values;
        for (let i = 0; i < this.testing.length; i++) {
          var QuoteStr = "" + i + "";
          this.ArrTest.push({ key: QuoteStr, label: this.testing[i] });
        }
        this.UserHeaders = this.ArrTest;
        this.ArrTest = [];
      });
    },
    CallSearch: function() {
      let config = { "x-api-key": "NbXi6fRPzS3ldUKOBMGHleSEiwjjUmX6InALhupb" };
      let url =
        "https://4a3q6cjio6.execute-api.eu-west-2.amazonaws.com/" +
        this.$environment +
        "/search?";
      if (this.searchUnitID === null) {
        this.UnitSearchparam = "input_UnitID=&";
      } else {
        this.UnitSearchparam = "input_UnitID=" + this.searchUnitID + "&";
      }
      if (this.searchUnitStatus === null) {
        this.UnitStatusparam = "input_UnitStatus=&";
      } else {
        this.UnitStatusparam =
          "input_UnitStatus=" + this.searchUnitStatus + "&";
      }
      if (this.searchUnitsLocation === null) {
        this.UnitLocationparam = "input_UnitsLocation=&";
      } else {
        this.UnitLocationparam =
          "input_UnitsLocation=" + this.searchUnitsLocation + "&";
      }
      if (this.searchUnitLevel === null) {
        this.UnitLevelparam = "input_UnitsLevel=&";
      } else {
        this.UnitLevelparam = "input_UnitsLevel=" + this.searchUnitLevel + "&";
      }
      if (this.searchUserID === null) {
        this.UserSearchparam = "input_UserID=&";
      } else {
        this.UserSearchparam = "input_UserID=" + this.searchUserID + "&";
      }
      if (this.searchUsersLocation === null) {
        this.UserLocationparam = "input_UsersLocation=&";
      } else {
        this.UserLocationparam =
          "input_UsersLocation=" + this.searchUsersLocation + "&";
      }
      if (this.searchLocation === null) {
        this.Locationparam = "input_Location=&";
      } else {
        this.Locationparam = "input_Location=" + this.searchLocation + "&";
      }
      if (this.searchLocationbyTrust === null) {
        this.LocationTrustparam = "input_LocationTrust=&";
      } else {
        this.LocationTrustparam =
          "input_LocationTrust=" + this.searchLocationbyTrust + "&";
      }
      if (this.searchLocationbyArea === null) {
        this.LocationAreaparam = "input_LocationArea=&";
      } else {
        this.LocationAreaparam =
          "input_LocationArea=" + this.searchLocationbyArea + "&";
      }

      let searchparams =
        this.UnitSearchparam +
        this.UnitStatusparam +
        this.UnitLocationparam +
        this.UnitLevelparam +
        this.UserSearchparam +
        this.UserLocationparam +
        this.Locationparam +
        this.LocationTrustparam +
        this.LocationAreaparam;
      let getUrl = url + searchparams;
      alert(getUrl);
      axios.get(getUrl, { headers: config }).then((response) => {
        this.response2 = response.data;
      });
    },

    SetData() {},
  },
  computed: {},
};
</script>
